import { render, staticRenderFns } from "./Monitoring.vue?vue&type=template&id=2b1e96f4&"
import script from "./Monitoring.vue?vue&type=script&lang=js&"
export * from "./Monitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b1e96f4')) {
      api.createRecord('2b1e96f4', component.options)
    } else {
      api.reload('2b1e96f4', component.options)
    }
    module.hot.accept("./Monitoring.vue?vue&type=template&id=2b1e96f4&", function () {
      api.rerender('2b1e96f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/service/Monitoring.vue"
export default component.exports